import { supabase } from "../../config/supabase";

// Remove a challenge 
const removeChallenge = async (challengeId) => {
    try {
        const { error } = await supabase.from('challenges').delete().eq('challenge_id', challengeId);
        if (error) throw new Error(error);
        return { error: null };
    } catch (err) {
        console.log('an error in deleting challenges:',err);
        return { error: err };
    }
};

export { removeChallenge };